import { useContext } from "react";

import { CreateActionContext } from "../../context/sectionTabs/CreateActionContext";
import type { CreateActionContextValue } from "../../context/sectionTabs/types";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider.
 */
const FALLBACK_CONTEXT: CreateActionContextValue = {
  onCreateOpen: null,
  setOnCreateOpen: noop,
};

/**
 * Register/read the create-action drawer opener `MobileTopBarArea` owns,
 * so pages can trigger it from a page-specific trailing action (e.g.
 * FeedContent's create button).
 */
export const useMobileCreateAction = () => {
  const context = useContext(CreateActionContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileCreateAction: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
